import { Control, Icon } from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Leaflet угадывает путь к картинкам стандартного маркера по CSS, а после сборки Vite
// угадывает неверно. Пустой imagePath отключает угадывание, иначе он дописывается
// перед каждым URL.
Icon.Default.imagePath = '';
Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

// Убираем ссылку «Leaflet» из атрибуции; атрибуция данных карты (OSM) остаётся
Control.Attribution.mergeOptions({ prefix: false });
